enum ZIndex {
  AppBar = 20,
  CompetitiveAnalysis = 5,
  HelpModal = 10, // Needs to be above Competitive Analysis
  NitroGuidePanel = 1015, // Need to be above InsightsPanel
  MapButton = 10,
  InsightsPanel = 1010,
  SelectRailStationPanel = 1016, // Needs to be above InsightsPanel
  AddLocationPanel = 20,
  GuidancePanel = 20,
  SettingsPanel = 20,
  QuotesPanel = 20, // Needs to be above Competitive Analysis
  AddFOBIndicationPanel = 20,
  DeleteIndicationConfirmation = 21, // Needs to be above AddFOBIndicationPanel
  UnsavedConfirmation = 1020, // Needs to be above InsightsPanel and Product filter
  DeleteRailStationConfirmation = 1020, // Needs to be above InsightsPanel and AddLocationPanel
  OpaqueBackground = 100,
  FilterMenu = 100, // Make sure the menu shows above everything
}

export default ZIndex;
